export enum RelativeStart {
  None = 0,
  FiveMin = 1,
  TenMin = 2,
  FifteenMin = 3,
}
